export default "__VITE_ASSET__27443553__"